import React from 'react';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import ImageUpload from './components/ImageUpload';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <div className="app">
          <header className="app-header">
            <div className="header-content">
              <h1>📦 Atlas Image Upload</h1>
            </div>
          </header>
          
          <main className="app-main">
            <div className="upload-container">
              <ImageUpload />
            </div>
          </main>
          
          <footer className="app-footer">
            <p>
              Images are automatically optimized (400x400px, 72DPI) and delivered via CDN
            </p>
          </footer>
        </div>
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
